// extracted by css-extract-rspack-plugin
export default {"footer":"cfQL0XX9MbwuvinW__footer___","modalContainer":"oS2xtfx5fyUo5NQd__modalContainer___"};